"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _src = require("@seedlang/utils/src");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DeckSettingsWrapper = function DeckSettingsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  var DeckSettingsWrapperComponent = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function DeckSettingsWrapperComponent() {
      var _this;
      _classCallCheck(this, DeckSettingsWrapperComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, DeckSettingsWrapperComponent, [].concat(args));
      _initializerDefineProperty(_this, "showDescriptions", _descriptor, _this);
      _initializerDefineProperty(_this, "settingCache", _descriptor2, _this);
      _this.onToggleEnrichedSentences = function (value) {
        if (value) {
          (0, _lodash.each)(_state.DeckUI.animationCards, function (animationCard) {
            _state.DeckUI.enrichSentence(animationCard.card);
          });
        } else {
          _state.DeckUI.set('enrichedTranslations', {});
          (0, _lodash.each)(_state.DeckUI.deck.cards, function (card) {
            card.set('isEnriched', false);
          });
        }
      };
      _this.showDescription = function (name) {
        if (_this.showDescriptions.includes(name)) {
          _this.showDescriptions = _this.showDescriptions.filter(function (item) {
            return item !== name;
          });
        } else {
          _this.showDescriptions.push(name);
        }
      };
      _this.setNumberSetting = function (name, val) {
        _this.settingCache[name] = val;
      };
      _this.persistNumberSetting = function (name, val) {
        var updates = {};
        if (name !== undefined) {
          var numVal = Array.isArray(val) ? val[0] : val;
          if (_state.AppUI.user[name] !== numVal) {
            updates[name] = numVal;
            _state.AppUI.user.set(name, numVal);
          }
          delete _this.settingCache[name];
        } else {
          (0, _lodash.keys)(_this.settingCache).forEach(function (settingName) {
            var numVal = _this.settingCache[settingName];
            if ((0, _src.isPresent)(numVal) && _state.AppUI.user[settingName] !== numVal) {
              updates[settingName] = numVal;
              _state.AppUI.user.set(settingName, numVal);
            }
            delete _this.settingCache[settingName];
          });
        }
        if (Object.keys(updates).length > 0) {
          _state.AppUI.authUserStore.update({
            data: updates
          }, _state.AppUI.loadUser);
        }
      };
      return _this;
    }
    _inherits(DeckSettingsWrapperComponent, _React$Component);
    return _createClass(DeckSettingsWrapperComponent, [{
      key: "inDeckSettingsContext",
      get: function get() {
        var _this$props$route;
        if ((0, _src.isPresent)(this.props.inDeck)) {
          return this.props.inDeck;
        }
        if ((_this$props$route = this.props.route) !== null && _this$props$route !== void 0 && _this$props$route.name) {
          return this.props.route.name === 'DeckSettings';
        }
        return _state.DeckUI.hasDeck;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if ((0, _src.isPresent)(this.settingCache)) {
          this.persistNumberSetting();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _AppUI$user, _AppUI$user$languageI, _AppUI$user$languageI2;
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showDescription: this.showDescription,
          showDescriptions: this.showDescriptions,
          settingCache: this.settingCache,
          setNumberSetting: this.setNumberSetting,
          persistNumberSetting: this.persistNumberSetting,
          categories: [{
            title: 'All Cards',
            settings: [{
              name: 'blockMediaAccess',
              label: 'Give Microphone Access',
              description: 'Practice your speaking and pronunciation by recording your answers. We never save your audio without your permission.',
              toggleShowsOppositeValue: true,
              alerts: [{
                slug: 'browserNotSupported',
                show: !_state.DeckUI.layout.mediaRecorderSupported,
                message: 'We do not support recording audio with your browser.'
              }, {
                slug: 'recordingBlocked',
                show: _state.DeckUI.layout.mediaRecorderSupported && _state.DeckUI.deviceDeniedAccess,
                message: 'Recording has been blocked within your browser.'
              }]
            }, {
              name: 'showDeckArrowBox',
              label: 'Show Help Tips',
              description: 'Display tips to help you navigate through decks.'
            }, {
              name: 'askConfirmationDeckClose',
              label: 'Ask Before Closing Deck',
              description: 'Ask for confirmation when you tap the close icon in a deck.'
            }, {
              name: 'useSoundEffects',
              label: 'Play Sound Effects',
              description: 'Sound effects include the coin sound effect, checkpoint horn, game won and lost, and more.'
            }, {
              name: 'showCardAnimation',
              label: 'Show Card Swipe Animation',
              description: 'Transition between flashcards seamlessly by allowing animations.'
            }, {
              name: 'showCoinAnimation',
              label: 'Show Coin Animation',
              description: 'Display a coin animation if you receive XP on a card.'
            }, {
              name: 'showSpecialCharacters',
              label: 'Show Special Characters',
              description: 'Show special characters unique to the language that you are learning when viewing text inputs.'
            }, {
              name: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.showVocabMeanings.name,
              label: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.showVocabMeanings.deckLabel || _constants.Constants.VOCAB_TRANSLATION_SETTINGS.showVocabMeanings.label,
              description: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.showVocabMeanings.description
            }]
          }, {
            title: 'Language',
            hide: !this.inDeckSettingsContext,
            settings: [{
              name: 'languageId',
              label: 'Your Native Language',
              description: 'Display translations in this language when available.',
              type: 'select',
              options: _state.AppUI.nativeLanguageOptionsForLanguageId((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.languageId)
            }, {
              name: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.onlyShowNativeLanguage.name,
              label: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.onlyShowNativeLanguage.deckLabel || _constants.Constants.VOCAB_TRANSLATION_SETTINGS.onlyShowNativeLanguage.label,
              description: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.onlyShowNativeLanguage.description,
              hide: (_AppUI$user$languageI = _state.AppUI.user.languageId) === null || _AppUI$user$languageI === void 0 ? void 0 : _AppUI$user$languageI.startsWith('EN')
            }, {
              name: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.showNativeLanguageFirst.name,
              label: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.showNativeLanguageFirst.label,
              description: _constants.Constants.VOCAB_TRANSLATION_SETTINGS.showNativeLanguageFirst.description,
              hide: ((_AppUI$user$languageI2 = _state.AppUI.user.languageId) === null || _AppUI$user$languageI2 === void 0 ? void 0 : _AppUI$user$languageI2.startsWith('EN')) || _state.AppUI.user[_constants.Constants.VOCAB_TRANSLATION_SETTINGS.onlyShowNativeLanguage.name]
            }]
          }, {
            title: 'Reviews',
            settings: [{
              name: 'reviewsDueAtBeginningOfDay',
              label: 'Reviews Due at Beginning of Day',
              description: 'If enabled, reviews due throughout the day will all become due at the start of the day instead of at their specific due times.'
            }, {
              name: 'newReviewsDueImmediately',
              label: 'New Reviews Are Due Immediately',
              description: 'If toggled off, new reviews will become due on the next day.'
            }, {
              name: 'disableRetiringReviews',
              label: 'Disable Retiring Reviews',
              description: 'When reviews have been in your deck long enough, they will be retired. Disabling this means they will never be retired.'
            }, {
              hide: _state.AppUI.user.disableRetiringReviews,
              name: 'daysUntilReviewRetired',
              label: 'Days Until Review is Retired',
              description: 'The number of days that we use as a threshold to determine if a card should be retired. If the setting is 180, then if a card is pushed more than 180 days into the future after a review, it will be retired.',
              type: 'number',
              minimumValue: 100,
              maximumValue: 400,
              step: 10
            }, {
              name: 'convertCardSubmissions',
              label: 'Convert Custom Reviews',
              description: 'When words from your custom cards are added to our dictionary and recorded, the cards will be converted to word translation cards.'
            }]
          }, {
            title: 'Story Cards',
            settings: [{
              name: 'listeningComprehensionMode',
              label: 'Enable Listening Comprehension',
              description: 'Delay subtitles until after the video has played to strengthen your listening comprehension.'
            }, {
              name: 'supplementMaximized',
              label: 'Maximize Demonstration Video',
              description: 'Expand the demonstration video when there are two videos in a Story. Toggling this off will maximize the narration video and minimize the demonstration video.'
            }]
          }, {
            title: 'Vocab Cards',
            settings: [{
              name: 'evaluateVocabOnKeystroke',
              label: 'Evaluate Answer while Typing',
              description: 'Automatically advance to the next card without pressing the "Submit" button when your answers are correct.'
            }, {
              name: 'hideVocabTargetUntilRevealed',
              label: 'Hide Target Until Revealed',
              description: 'When words or sentences are introduced, don\'t show the target language until the card has been revealed.'
            }, {
              name: 'enforceCasing',
              label: 'Require Correct Letter Case',
              description: 'An answer will only be correct if you typed the uppercase and lowercase letters correctly.'
            }, {
              name: 'masculineGenderColor',
              label: 'Masculine Nouns Color',
              description: 'The color of the background of cards for masculine nouns.',
              type: 'select',
              options: _constants.Constants.COLOR_OPTIONS
            }, {
              name: 'feminineGenderColor',
              label: 'Feminine Nouns Color',
              description: 'The color of the background of cards for feminine nouns.',
              type: 'select',
              options: _constants.Constants.COLOR_OPTIONS
            }, {
              name: 'neuterGenderColor',
              label: 'Neuter Nouns Color',
              description: 'The color of the background of cards for neuter nouns.',
              type: 'select',
              options: _constants.Constants.COLOR_OPTIONS
            }]
          }, {
            title: 'Trivia Cards',
            settings: [{
              name: 'playTriviaWithOpponents',
              label: 'Play Trivia with Opponents',
              description: 'Compete against other players in trivia games. Turn this off to practice trivia in solo mode.'
            }, {
              name: 'simplifiedTriviaDecks',
              label: 'Show Simplified Trivia Cards',
              description: 'This will not show the response video indicating whether you answered correctly or not. This is useful for people who are experiencing issues with videos not loading in trivia decks.'
            }]
          }, {
            title: 'Mobile',
            settings: [{
              name: 'darkModeMobile',
              label: 'Dark Mode',
              description: 'Set the dark mode for the mobile app.',
              type: 'select',
              options: [['system', 'System'], ['light', 'Light'], ['dark', 'Dark']]
            }, {
              name: 'useHaptics',
              label: 'Use Haptic Effects',
              description: 'Turn on haptic effects for feedback on your progress while you go through flashcards.'
            }, {
              name: 'disableAndroidKeyboardSuggestions',
              label: 'Disable Keyboard Suggestions',
              description: 'Test yourself every step of the way by hiding keyboard suggestions. This will also disable swiping to type.'
            }, {
              name: 'mobileTextDirection',
              label: 'Text Direction',
              description: 'The order text is displayed in sentences.',
              type: 'select',
              options: [['auto', 'Auto'], ['forward', 'Forward'], ['reverse', 'Reverse']],
              hide: !_state.AppUI.layout.isNative
            }]
          }, {
            title: 'Advanced Settings',
            settings: [{
              name: 'showEnrichedSentences',
              label: 'Show Word Details',
              description: 'Turning this off will result in smaller deck sizes and less data being transfered.',
              onToggle: this.onToggleEnrichedSentences
            }, {
              name: 'muteInterjections',
              apiName: 'mute_interjections',
              label: 'Mute Final Card of Decks',
              description: 'Remove the encouraging video and the fanfare sound at the end of decks.'
            }, {
              name: 'webAllowVideoOverlap',
              label: 'Allow Videos to Overlap',
              description: 'Certain cards have overlapping videos. Enabling this will allow videos to overlap.',
              hide: _state.AppUI.layout.isNative
            }, {
              name: 'iosAllowVideoOverlap',
              label: 'Allow Videos to Overlap',
              description: 'Certain cards have overlapping videos. Enabling this will allow videos to overlap.',
              hide: !_state.AppUI.layout.isNative || !_state.AppUI.layout.isIos
            }, {
              name: 'androidAllowVideoOverlap',
              label: 'Allow Videos to Overlap',
              description: 'Certain cards have overlapping videos. Enabling this will allow videos to overlap.',
              hide: !_state.AppUI.layout.isNative || _state.AppUI.layout.isIos
            }]
          }, {
            title: 'Admin',
            hide: !_state.AppUI.isDevelopment && !(_state.AppUI.user.admin || _state.AppUI.user.showAdminTools),
            settings: [{
              name: 'displayDeckDebugInfo',
              label: 'Show Debug Info',
              description: 'Displays debugging information for troubleshooting.'
            }]
          }]
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showDescriptions", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "settingCache", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "inDeckSettingsContext", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inDeckSettingsContext"), _class2.prototype), _class2)) || _class;
  ;
  return DeckSettingsWrapperComponent;
};
DeckSettingsWrapper.displayName = 'DeckSettingsWrapper';
var _default = exports["default"] = DeckSettingsWrapper;